import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  stockReceiptsControllerCancel,
  stockReceiptsControllerCreate,
  StockReceiptsControllerCreate$Params,
  stockReceiptsControllerFindAll,
  StockReceiptsControllerFindAll$Params,
  stockReceiptsControllerFindById,
} from '@klubovna/api-client';
import { CreateStockReceiptDto, StockReceipt } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StockReceiptsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: StockReceiptsControllerFindAll$Params): Observable<PaginatedResponse<StockReceipt>> {
    return stockReceiptsControllerFindAll(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => toPaginatedResponse<StockReceipt>(response.body)));
  }

  findById(id: string): Observable<StockReceipt> {
    return stockReceiptsControllerFindById(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(response => response.body as StockReceipt));
  }

  create(data: CreateStockReceiptDto): Observable<StockReceipt> {
    const params: StockReceiptsControllerCreate$Params = { body: data };
    return stockReceiptsControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as StockReceipt));
  }

  cancel(id: string): Observable<StockReceipt> {
    return stockReceiptsControllerCancel(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(response => response.body as StockReceipt));
  }
}
